// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as TraitName0 from "common/src/tft-static/TraitName0.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";

function CheatSheetPage$TraitHeader(Props) {
  var traitId = Props.traitId;
  var selectedTraits = Props.selectedTraits;
  var hoveredTraits = Props.hoveredTraits;
  var setSelectedTraits = Props.setSelectedTraits;
  var setHoveredTraits = Props.setHoveredTraits;
  var set = TftSet.use(undefined);
  var bg = selectedTraits.includes(traitId) || hoveredTraits.includes(traitId);
  return React.createElement(TraitTooltip.make, {
              trait: traitId,
              children: React.createElement("div", {
                    className: "flex flex-col justify-center items-center px-1 py-2 border-r border-b border-white2 cursor-pointer" + (
                      bg ? " bg-bg3" : ""
                    ),
                    onClick: (function (param) {
                        return Curry._1(setSelectedTraits, (function (st) {
                                      if (st.includes(traitId)) {
                                        return Belt_Array.keep(st, (function (t) {
                                                      return t !== traitId;
                                                    }));
                                      } else {
                                        return Belt_Array.concat(st, [traitId]);
                                      }
                                    }));
                      }),
                    onMouseLeave: (function (param) {
                        return Curry._1(setHoveredTraits, (function (param) {
                                      return [];
                                    }));
                      }),
                    onMouseOver: (function (param) {
                        return Curry._1(setHoveredTraits, (function (param) {
                                      return [traitId];
                                    }));
                      })
                  }, React.createElement(TraitImage.PlainIcon.make, {
                        traitId: traitId,
                        size: 24
                      }), React.createElement("div", {
                        className: "text-xs"
                      }, React.createElement(TraitName0.make, {
                            trait: traitId
                          })), React.createElement("div", {
                        className: "text-xs"
                      }, Belt_Array.map(Sd.traitRankCounts(traitId, set), (function (prim) {
                                return String(prim);
                              })).join("/")))
            });
}

var TraitHeader = {
  make: CheatSheetPage$TraitHeader
};

function CheatSheetPage$Inner(Props) {
  var set = TftSet.use(undefined);
  Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return [];
      });
  var setSelectedTraits = match[1];
  var selectedTraits = match[0];
  var match$1 = React.useState(function () {
        return [];
      });
  var setHoveredTraits = match$1[1];
  var hoveredTraits = match$1[0];
  var match$2 = React.useState(function () {
        return true;
      });
  var useSkins = match$2[0];
  var allClasses = Belt_Array.keep(Sd.allClasses(set), (function (t) {
          if (Sd.isTraitUnique(t, set)) {
            return t === "TFT11_Artist";
          } else {
            return true;
          }
        }));
  var exaltedGroup = [];
  return React.createElement(AdLayout.make, {
              children: React.createElement(ContentSection.make, {
                    className: "mt-8",
                    children: null
                  }, React.createElement("div", {
                        className: "flex justify-between items-end pb-4"
                      }), React.createElement("div", {
                        className: CssJs.merge([
                              "bg-bg2 grid border-t border-l",
                              CssJs.style([CssJs.gridTemplateColumns([{
                                            NAME: "repeat",
                                            VAL: [
                                              {
                                                NAME: "num",
                                                VAL: 1 + allClasses.length | 0
                                              },
                                              CssJs.auto
                                            ]
                                          }])])
                            ])
                      }, React.createElement("div", {
                            className: "border-r border-b border-white2"
                          }), Belt_Array.map(allClasses, (function (traitId) {
                              return React.createElement(CheatSheetPage$TraitHeader, {
                                          traitId: traitId,
                                          selectedTraits: selectedTraits,
                                          hoveredTraits: hoveredTraits,
                                          setSelectedTraits: setSelectedTraits,
                                          setHoveredTraits: setHoveredTraits,
                                          key: traitId
                                        });
                            })), Belt_Array.map(Belt_Array.keep(Sd.allOrigins(set), (function (t) {
                                  return !Sd.isTraitUnique(t, set);
                                })), (function (origin) {
                              return React.createElement(React.Fragment, {
                                          children: null,
                                          key: origin
                                        }, React.createElement(CheatSheetPage$TraitHeader, {
                                              traitId: origin,
                                              selectedTraits: selectedTraits,
                                              hoveredTraits: hoveredTraits,
                                              setSelectedTraits: setSelectedTraits,
                                              setHoveredTraits: setHoveredTraits
                                            }), Belt_Array.map(allClasses, (function ($$class) {
                                                var traits = [
                                                  origin,
                                                  $$class
                                                ];
                                                var bg = Belt_Array.some(traits, (function (trait) {
                                                        if (selectedTraits.includes(trait)) {
                                                          return true;
                                                        } else {
                                                          return hoveredTraits.includes(trait);
                                                        }
                                                      }));
                                                var units = Belt_SortArray.stableSortBy(Belt_Array.keep(Sd.allUnits(set), (function (unitId) {
                                                            var traits = Sd.getUnitTraits(unitId, set);
                                                            if (traits.includes(origin)) {
                                                              if ($$class === "TFT11_Exalted" && exaltedGroup.includes(unitId)) {
                                                                return true;
                                                              } else {
                                                                return traits.includes($$class);
                                                              }
                                                            } else {
                                                              return false;
                                                            }
                                                          })), (function (u1, u2) {
                                                        return Caml.caml_int_compare(Sd.unitTier(u1), Sd.unitTier(u2));
                                                      }));
                                                return React.createElement("div", {
                                                            key: $$class,
                                                            className: "min-w-[57px] lg:min-w-[61px] flex-shrink-0 flex flex-col gap-[10px] justify-center items-center px-2 py-3 border-r border-b border-white2 cursor-pointer" + (
                                                              bg ? " bg-bg3" : ""
                                                            ),
                                                            onClick: (function (param) {
                                                                var includes = selectedTraits.includes(origin) && selectedTraits.includes($$class);
                                                                Curry._1(setSelectedTraits, (function (selectedTraits) {
                                                                        var filtered = Belt_Array.keep(selectedTraits, (function (t) {
                                                                                if (t !== origin) {
                                                                                  return t !== $$class;
                                                                                } else {
                                                                                  return false;
                                                                                }
                                                                              }));
                                                                        if (includes) {
                                                                          return filtered;
                                                                        } else {
                                                                          return Belt_Array.concat(filtered, [
                                                                                      origin,
                                                                                      $$class
                                                                                    ]);
                                                                        }
                                                                      }));
                                                                if (includes) {
                                                                  return Curry._1(setHoveredTraits, (function (param) {
                                                                                return [];
                                                                              }));
                                                                }
                                                                
                                                              }),
                                                            onMouseLeave: (function (param) {
                                                                return Curry._1(setHoveredTraits, (function (param) {
                                                                              return [];
                                                                            }));
                                                              }),
                                                            onMouseOver: (function (param) {
                                                                return Curry._1(setHoveredTraits, (function (param) {
                                                                              return [
                                                                                      origin,
                                                                                      $$class
                                                                                    ];
                                                                            }));
                                                              })
                                                          }, Belt_Array.mapWithIndex(units, (function (idx, unitId) {
                                                                  return React.createElement(UnitTooltip.make, {
                                                                              unit: unitId,
                                                                              children: React.createElement(UnitImage.make, {
                                                                                    skin: useSkins,
                                                                                    unitId: unitId,
                                                                                    size: 40,
                                                                                    sizeLg: 44
                                                                                  }),
                                                                              key: String(idx)
                                                                            });
                                                                })));
                                              })));
                            }))))
            });
}

var Inner = {
  make: CheatSheetPage$Inner
};

function CheatSheetPage(Props) {
  var set = Props.set;
  var exalteds = Props.exalteds;
  return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(TftSet.fromNum(set), React.createElement(CheatSheetPage$Inner, {
                      exalteds: exalteds
                    }), undefined));
}

var make = CheatSheetPage;

export {
  TraitHeader ,
  Inner ,
  make ,
  
}
/* Sd Not a pure module */
